import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { plans } from '../../data/pricing';
import { costSections, type CostRow } from '../../data/additionalCosts';
import { CostCell } from './CostCell';
import { QuotedList } from './QuotedList';
const labelCell = 'border-b border-gray-200 bg-white px-6 py-3 text-left align-middle';
const valueCell = 'border-b border-l border-gray-200 px-4 py-3 text-center align-middle';
export function CostsTable() {
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});
  const renderRow = (row: CostRow, indent = false) => <tr key={row.label} data-id="element-42" data-mp="3bvf9xodstx04">
      <th scope="row" className={`${labelCell} font-normal ${indent ? 'pl-10' : ''}`} data-id="element-43" data-mp="3bv5gfqtjp7po">
        <span className="block text-sm font-semibold text-gray-900" data-id="element-44" data-mp="3gnp3dee4hf75">{row.label}</span>
        {row.detail && <span className="mt-0.5 block text-xs text-gray-500" data-id="element-45" data-mp="2k3pxq7v4054q">{row.detail}</span>}
      </th>
      {plans.map(plan => <td key={plan.id} className={valueCell} data-id="element-46" data-mp="2o4t7ccmkd4xi">
          <CostCell value={row.values[plan.id]} accentClass={plan.accentText} data-id="element-47" data-mp="267iqaycc5hz3" />
        </td>)}
    </tr>;
  return <div className="mx-auto hidden max-w-[1440px] border border-gray-200 shadow-sm lg:block" data-id="element-48" data-mp="218z4qz1nm879">
      <table className="w-full table-fixed border-collapse" data-id="element-49" data-mp="1wg5xo4ipqns0">
        <colgroup data-id="element-50" data-mp="1ri4e7ihdkmg0">
          <col className="w-[28%]" data-id="element-51" data-mp="1rimmxel84t4t" />
          {plans.map(plan => <col key={plan.id} className="w-[18%]" data-id="element-52" data-mp="1rga2murzu6ol" />)}
        </colgroup>

        <thead data-id="element-53" data-mp="1mgx6fjf8fn9c">
          <tr data-id="element-54" data-mp="1ihg1cr3pws4p">
            <th scope="col" className="sticky top-24 z-20 border-b border-gray-200 bg-white px-6 py-3 text-left text-xs font-bold uppercase tracking-[0.14em] text-brand-gray" data-id="element-55" data-mp="1ihohqsz1ufkn">
              Package
            </th>
            {plans.map(plan => <th key={plan.id} scope="col" className={`sticky top-24 z-20 ${plan.bandClass} px-4 py-2.5 text-center font-normal`} data-id="element-56" data-mp="18l38fvfzyib0">
                <span className="block text-[11px] font-bold uppercase tracking-[0.14em]" data-id="element-57" data-mp="32x9vbri96nj5">{plan.name}</span>
                <span className="text-sm font-extrabold" data-id="element-58" data-mp="118dqwqsp3wpn">
                  {plan.price}
                  <span className={`text-xs font-medium ${plan.subtleText}`} data-id="element-59" data-mp="15yu6ohjznuf6">/mo</span>
                </span>
              </th>)}
          </tr>
        </thead>

        <tbody data-id="element-60" data-mp="rbr7m6g0pdpq">
          {costSections.map(section => <React.Fragment key={section.id} data-id="element-61" data-mp="wa2imki1tu9j">
              <tr data-id="element-62" data-mp="w6wpmu6au88j">
                <th scope="colgroup" colSpan={plans.length + 1} className="bg-brand-red px-6 py-3 text-left text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-63" data-mp="1jylo6s9prsxx">
                  {section.title}
                </th>
              </tr>

              {section.rows.map(row => renderRow(row))}

              {section.group && <>
                  <tr data-id="element-64" data-mp="3uqde0fkqhdwy">
                    <td colSpan={plans.length + 1} className="border-b border-gray-200 bg-gray-50 p-0" data-id="element-65" data-mp="3up3h3tpmabrw">
                      <button type="button" aria-expanded={!!openGroups[section.id]} onClick={() => setOpenGroups(g => ({
                  ...g,
                  [section.id]: !g[section.id]
                }))} className="flex w-full items-center gap-2 px-6 py-3 text-left text-sm font-bold text-brand-black transition-colors duration-150 ease-out hover:text-brand-red focus:outline-none focus-visible:text-brand-red" data-id="element-66" data-mp="3ln5k3ih9m0u">
                        <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${openGroups[section.id] ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-67" data-mp="1z24ykc5jrxvg" />
                        {section.group.title}
                      </button>
                    </td>
                  </tr>
                  {openGroups[section.id] && section.group.rows.map(row => renderRow(row, true))}
                </>}

              {section.quoted && <tr data-id="element-68" data-mp="1o1a0uiy9j06i">
                  <td colSpan={plans.length + 1} className="border-b border-gray-200 bg-white px-6 py-6" data-id="element-69" data-mp="1o1s0zqo1pyjp">
                    <QuotedList items={section.quoted.items} line={section.quoted.line} data-id="element-70" data-mp="1szlb2usgzcp9" />
                  </td>
                </tr>}

              {(section.note || section.footnote) && <tr data-id="element-71" data-mp="22r7qz4fr5zyc">
                  <td colSpan={plans.length + 1} className="border-b border-gray-200 bg-gray-50 px-6 py-3 text-xs leading-relaxed text-gray-600" data-id="element-72" data-mp="22rqxzq3v73xl">
                    {section.note ?? section.footnote}
                  </td>
                </tr>}
            </React.Fragment>)}
        </tbody>
      </table>
    </div>;
}